<template>
    <div class="popover company-popover" v-if="company">
        <div class="header">
            <CompanyAvatar :company="company" size="medium" />
            <div class="details">
                <router-link :to="`/companies/${company.id}`" class="primary-link">{{ company.symbol }}</router-link>
                <br />
                {{ company.name }}
            </div>
            <div class="rating" v-if="!company.restricted && rating">
                <OverallRating :entity="company" />
                <span>MTR</span>
            </div>
        </div>
        <div class="button-set" v-if="company.tracked">
            <router-link :to="`/companies/${company.id}`" class="button secondary small"> View Profile </router-link>
            <WatchlistButton
                entity-type="Company"
                :entity-id="company.id"
                class="small"
                button-type="primary"
                v-if="!company.restricted"
            />
        </div>
    </div>
</template>
<script setup>
import CompanyService from '@/services/companyService'
import CompanyAvatar from '@/components/companies/avatar.vue'
import OverallRating from '../shared/overall-rating.vue'
import WatchlistButton from '@/components/shared/watchlist-button.vue'

import { computed } from 'vue'

import { asyncComputed } from '@/utils/asyncComputed.js'
import { features } from '@/store/features'

let __company = null

const props = defineProps({
    value: {
        type: Object,
        default() {
            return {}
        },
    },
})

const company = asyncComputed(async () => {
    if (props.value.ratings) {
        return props.value
    }
    if (__company && __company.id == props.value.id && __company.ratings) {
        return __company
    }

    try {
        const company = await CompanyService.getSummary(props.value.id)

        if (company?.id == props.value.id) {
            __company = company
        }
    } catch {}

    return __company || props.value
}, props.value)

const rating = computed(() => {
    if (!features.euroRatingEnabled && company.value?.ratings?.overall?.group === 'EU') {
        return null
    }

    return company.value?.ratings?.overall?.ratingValue?.toFixed(1)
})
</script>
